import withDebugId from '../lib/withDebugId';
export var createTheme = function createTheme(themeInput, debugId) {
  return withDebugId(themeInput, debugId);
};